import React from 'react';
import { Form } from 'formik';
import JsaForm from '../JsaForm/JsaForm';
import setInitialValues from '../JsaForm/setInitialValues';
import { useJsaQuery } from '../../hooks';
import ContentLoader from '../../components/ContentLoader/ContentLoader';
import MyTeam from './MyTeam';

const MyTeamForm = function ({ handleModalClose }: any) {
  const { data, loading } = useJsaQuery();

  if (!data) {
    return <ContentLoader />;
  }

  const initialValues = setInitialValues(data);

  return (
    <JsaForm initialValues={initialValues} isLoading={loading} shouldAutosave={false}>
      <Form>
        <MyTeam handleModalClose={handleModalClose} />
      </Form>
    </JsaForm>
  );
};

export default MyTeamForm;
